import { $analyticsCustomReports } from '@/services/'

export default {
    namespaced: true,
    state: {
        timeFormat: {},
        fileTypes: {},
        defaultFields: {},
        customFields: {},
        selectedFields: [],
        selectedISPs: [],
        id: null,
        ctags: [],
        reportCreated: false,
        name: '',
        campaigns: [],
        recurringDate: '',
        recurringTime: '',
        lists: [],
        isLoading: true,
        isps: {},
        type: '',
        selectedReportType:null,
    },
    getters: {
        getReportType: state => state.selectedReportType,
        getFileType: state => state.fileTypes,
        getTimeFormat :state => state.timeFormat
    },
    mutations: {
        setCampaignReport (state, payload) {
            state.fileTypes = payload.file_types
            state.defaultFields = payload.default_fields
            state.customFields = payload.custom_report_fields
            state.timeFormat = payload.time_format
            state.isps = payload.isps
          },
          setReportType: (state, value) => state.type = value,
          setRecurringTime: (state, value) => state.recurringTime = value,
          setRecurringDate: (state,value) => state.recurringDate = value,
          setSelectedFields: (state, value) => state.selectedFields = value,
          setCampaigns: (state, value) => state.campaigns = value
    },
    actions: {
        getReport({ commit, state }) {
            $analyticsCustomReports.fetchNewReport({
                params: {
                  report_type: state.type,
                },
              }).then(response => {
                commit('setCampaignReport', response.data.data)
            })
        }
    }
}